import axios from "axios";

// Function to get CSRF token from cookies
const getCSRFToken = () => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken="))
    ?.split("=")[1];
};

// Create an Axios instance with global defaults
const axiosInstance = axios.create({
  baseURL: "https://portal.perldbase.com",
  withCredentials: true, // Ensures cookies (session, CSRF) are sent
});

// Add CSRF token to every request automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const csrfToken = getCSRFToken();
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Send the user back to login if their session or CSRF cookie has gone
// (401 = not logged in, 403 with no csrftoken = "CSRF cookie not set")
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const sessionLost = status === 401 || (status === 403 && !getCSRFToken());
    const onLoginPage = ["/login", "/auth"].includes(window.location.pathname);
    if (sessionLost && !onLoginPage) {
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
